import { TP_HeatingGenerator } from './types'
import { LoadingView } from "../../../../components";
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren'
import { FormattedMessage } from 'react-intl'
import { PlantSwitchesGrid } from '../../components/PlantSwitches';
import { FilteredAppsView } from '../../../components/FilteredAppsView';
import { ISchemaSortDictionary, sortBySchema } from '../../../components/FilteredAppsView/FilteredAppsView';
import { isParameterApp } from '../../../parameterApps';
import { filterPlantSwitches } from '../../components/PlantSwitches/PlantSwitchesGrid';
import { IAutomationObject } from '../../../types';
import { PlantInsightApps } from '../../types';


export function OperatorPanel(props: TP_HeatingGenerator) {

    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    return (

        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <PlantSwitchesGrid childElements={children}></PlantSwitchesGrid>

            <FilteredAppsView
                header={<FormattedMessage id="P_CoolingHeating.Flow" defaultMessage={'Flow'} />}
                apps={children ?? []}
                filter={filterFlow}
                sort={(a, b) => sortBySchema(a, b, sortFlowDict)}>
            </FilteredAppsView>

            <FilteredAppsView
                header={<FormattedMessage id="P_CoolingHeating.Outlet" defaultMessage={'Outlet'} />}
                apps={children ?? []}
                filter={filterOutlet}
                sort={(a, b) => sortBySchema(a, b, sortOutletDict)}>
            </FilteredAppsView>

            <FilteredAppsView
                header={<FormattedMessage id="P_CoolingHeating.Puffer" defaultMessage={'Puffer'} />}
                apps={children ?? []}
                filter={filterPuffer}>
            </FilteredAppsView>

            <FilteredAppsView
                header={<FormattedMessage id="P_CoolingHeating.FlowSecondary" defaultMessage={'Flow Secondary'} />}
                apps={children ?? []}
                filter={filterFlowSecondary}>
            </FilteredAppsView>

            <FilteredAppsView
                header={<FormattedMessage id="P_CoolingHeating.OutletSecondary" defaultMessage={'Outlet Secondary'} />}
                apps={children ?? []}
                filter={filterOutletSecondary}>
            </FilteredAppsView>

            <FilteredAppsView
                header={<FormattedMessage id="P_Plant.Others" defaultMessage={'Others'} />}
                apps={children ?? []}
                filter={filterOthers}>
            </FilteredAppsView>

        </LoadingView>
    );
}



const filterFlow = (a: any) => {
    return a.schema === "AutomationApps.SubPlants.HeatingGenerators.SP_HeatingGenerator"
        || a.schema === "AutomationApps.SubPlants.HeatingCoils.SP_HeatingCoil"
        || a.schema === "AutomationApps.SubPlants.Pipes.SP_FlowPipe"
        || a.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryFlowPipe"
}
const sortFlowDict: ISchemaSortDictionary = {
    "AutomationApps.SubPlants.HeatingGenerators.SP_HeatingGenerator": 1,
    "AutomationApps.SubPlants.HeatingCoils.SP_HeatingCoil": 2,
    "AutomationApps.SubPlants.Pipes.SP_FlowPipe": 3,
    "AutomationApps.SubPlants.Pipes.SP_PrimaryFlowPipe": 4,
}

const filterOutlet = (a: any) => {
    return a.schema === "AutomationApps.SubPlants.Pipes.SP_OutletPipe"
        || a.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryOutletPipe"
}
const sortOutletDict: ISchemaSortDictionary = {
    "AutomationApps.SubPlants.Pipes.SP_OutletPipe": 1,
    "AutomationApps.SubPlants.Pipes.SP_PrimaryOutletPipe": 2,
}
const filterPuffer = (a: any) => {
    return a.schema === "AutomationApps.SubPlants.Puffers.SP_Puffer"
}
const filterFlowSecondary = (a: any) => {
    return a.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryFlowPipe"
}
const filterOutletSecondary = (a: any) => {
    return a.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryOutletPipe"
}

const filterOthers = (a: IAutomationObject) => {
    return !filterFlow(a) 
    && !filterOutlet(a) 
    && !filterPuffer(a) 
    && !filterFlowSecondary(a) 
    && !filterOutletSecondary(a)
    && !isParameterApp(a.schema) 
    && !filterPlantSwitches(a)
    && !PlantInsightApps.includes(a.schema)
}